// extracted by mini-css-extract-plugin
export var deleteIcon = "_s3-5";
export var deleteOption = "_s3-3";
export var divider = "_s3-2";
export var downloadIcon = "_s3-4";
export var drawer = "_s3-0";
export var drawerFooter = "_s3-6";
export var drawerOpen = "_s3-1";
export var highlighted = "_s3-7";
export var lighterHighlight = "_s3-8";